export default __webpack_public_path__ + "static/media/profile.1dd13a49.jpg";